import { styled } from "../../../../styled-components";

export const BarChartContentContainer = styled.div`
    display: flex;
    flex-direction: column;

    padding: 12px 0;
`;

export const BarChartContainer = styled.div<{ showLabel: boolean }>`
    position: relative;

    height: 210px;

    display: flex;

    margin: 0 ${p => p.theme.pageMarginMedium}px;
    margin-bottom: ${p => (p.showLabel ? `34px` : `16px`)};
`;

export const BarGraphContainer = styled.div`
    .value-separator {
        height: 30px;
        width: 100%;
        line-height: 29px;

        display: flex;
        align-items: flex-end;

        ${p => p.theme.fontStyles.Body6};
        color: ${p => p.theme.fgColorMedium};

        ::after {
            content: "";
            position: absolute;

            width: 100%;
            height: 1px;

            background-color: ${p => p.theme.separatorColor};
        }
    }
`;

export const BarOverlay = styled.div`
    position: absolute;
    z-index: 10;

    width: calc(100% - 24px);
    height: 40px;

    top: 8px;
    margin-left: 24px;

    box-shadow: 1px 1px 1px ${p => p.theme.separatorColor};
    background-color: ${p => p.theme.fgColorOpaque};
    border-radius: 8px;

    display: flex;
    align-items: center;

    pointer-events: none;
`;

export const BarOverlayContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 0 12px;
    width: 100%;

    color: ${p => p.theme.baseColor};
`;

export const BarOverlayContentLeft = styled.div`
    display: flex;
    align-items: center;

    flex-grow: 1;
    width: 1px;
`;

export const BarOverlayContentRight = styled.div`
    ${p => p.theme.fontStyles.Body4};
`;

export const OverlayText = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    flex-shrink: 1;
`;

export const Bars = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    flex-grow: 1;

    padding-top: 30px;
    padding-left: 8px;
`;

export const Bar = styled.div`
    position: relative;

    height: 100%;

    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    flex-grow: 1;
    margin-right: 8px;
`;

export const BarLabel = styled.div`
    position: absolute;

    height: 30px;
    width: 100%;

    bottom: -30px;
`;

export const LabelText = styled.div`
    width: 100%;

    margin-top: 8px;
    padding-right: 8px;

    text-align: center;
    ${p => p.theme.fontStyles.Body6};
    font-size: 10px; // fixme
    color: ${p => p.theme.fgColorMedium};

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

interface BarColorProps {
    color: string;
    top: number;
    bottom: number;
    numberOfItems: number;
    itemIndex: number;
}

export const BarColor = styled.div<BarColorProps>`
    position: absolute;

    top: 0;
    height: 100%;
    left: calc(calc(100% / ${p => p.numberOfItems}) * ${p => p.itemIndex});
    width: calc(100% / ${p => p.numberOfItems});

    .bar-color-inner {
        position: absolute;

        bottom: ${p => p.bottom * 100}%;
        top: ${p => p.top * 100}%;
        width: max(2px, calc(100% - 2px));
        left: 0;

        content: "";

        background-color: ${p => p.color};
        border-radius: 2px;
    }

    & .bar-color-inner.active {
        background-color: ${p => p.color}33;
    }

    && .bar-color-inner.hover {
        background-color: ${p => p.color};
    }
`;

export const BarsContainer = styled.div`
    display: flex;
    height: 100%;
`;
